<p-card styleClass="flex w-full h-full p-4">
  <ng-template pTemplate="header">
    <div class="flex justify-between items-center">
      <h2>Registration Leaderboard</h2>
      <app-icon-button 
        [icon]="icons.solid.faArrowUpRightFromSquare" 
        [text]="false"
        textSize="text-sm"
        (onClick)="openExpandDialog()"
        pTooltip="Expand All Tables"
        tooltipPosition="top">
      </app-icon-button>
    </div>
  </ng-template>
  <div class="content">
    @if(loading()) {
    <div class="loading">
      Loading leaderboard data...
    </div>
    }
    @if(error()) {
    <div class="error">
      {{ error() }}
    </div>
    }
    <div *ngIf="!loading() && !error()" class="leaderboard-content">
      <!-- Main Tables -->
      <div class="grid grid-cols-3 gap-4">
        <!-- Week Table -->
        <div class="table-container">
          <h3>This Week</h3>
          <div class="h-full">
            <p-table [value]="weekTableData" [rows]="5" [paginator]="true" styleClass="p-datatable-sm">
              <ng-template pTemplate="header">
                <tr>
                  @for (col of weekMonthYearColumns(); track col.field) {
                  <app-table-header [column]="col"></app-table-header>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr [style.color]="isCurrentUser(item.staffId) ? 'rgb(28, 132, 198)' : null" [class.font-semibold]="isCurrentUser(item.staffId)">
                  @for (col of weekMonthYearColumns(); track col.field) {
                  <app-table-column [column]="col" [data]="item"></app-table-column>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="4" class="text-center p-4">
                    No registrations so far this week... it could start with you!
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          @if(allTimeLoading()) {
          <div>Loading...</div>
          }
          @else {
          <div *ngIf="allTimeRecruiterWeekData.length > 0" class="all-time-leader mt-3 p-3 bg-surface-100 dark:bg-surface-800 rounded">
            <div class="text-sm font-semibold mb-1">All Time Leader:</div>
            <div class="flex justify-between items-center">
              <div class="flex items-center gap-2">
                <span>{{allTimeRecruiterWeekData[0].staffName}}</span>
                <span class="text-sm text-500">({{allTimeRecruiterWeekData[0].week | date:'MMM d, y'}})</span>
              </div>
              <span class="text-primary">{{allTimeRecruiterWeekData[0].participants}} participants</span>
              <span class="text-primary">{{allTimeRecruiterWeekData[0].teams}} teams</span>
            </div>
          </div>
          <button pButton label="View All Time" (click)="showAllTimeTable('week')" class="p-button-text"></button>
          }
        </div>

        <!-- Month Table -->
        <div class="table-container">
          <h3>This Month</h3>
          <div class="h-full">
            <p-table [value]="monthTableData" [rows]="5" [paginator]="true" styleClass="p-datatable-sm">
              <ng-template pTemplate="header">
                <tr>
                  @for (col of weekMonthYearColumns(); track col.field) {
                  <app-table-header [column]="col"></app-table-header>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr [style.color]="isCurrentUser(item.staffId) ? 'rgb(28, 132, 198)' : null" [class.font-semibold]="isCurrentUser(item.staffId)">
                  @for (col of weekMonthYearColumns(); track col.field) {
                  <app-table-column [column]="col" [data]="item"></app-table-column>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="4" class="text-center p-4">
                    No registrations so far this month... it could start with you!
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          @if(allTimeLoading()) {
          <div>Loading...</div>
          }
          @else {
          <div *ngIf="allTimeRecruiterMonthData.length > 0" class="all-time-leader mt-3 p-3 bg-surface-100 dark:bg-surface-800 rounded">
            <div class="text-sm font-semibold mb-1">All Time Leader:</div>
            <div class="flex justify-between items-center">
              <div class="flex items-center gap-2">
                <span>{{allTimeRecruiterMonthData[0].staffName}}</span>
                <span class="text-sm text-500">({{allTimeRecruiterMonthData[0].month | date:'MMM yyyy'}})</span>
              </div>
              <span class="text-primary">{{allTimeRecruiterMonthData[0].participants}} participants</span>
              <span class="text-primary">{{allTimeRecruiterMonthData[0].teams}} teams</span>
            </div>
          </div>
          <button pButton label="View All Time" (click)="showAllTimeTable('month')" class="p-button-text"></button>
          }
        </div>

        <!-- Year Table -->
        <div class="table-container">
          <h3>This Year</h3>
          <div class="h-full">
            <p-table [value]="yearTableData" [rows]="5" [paginator]="true" styleClass="p-datatable-sm">
              <ng-template pTemplate="header">
                <tr>
                  @for (col of weekMonthYearColumns(); track col.field) {
                  <app-table-header [column]="col"></app-table-header>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr [style.color]="isCurrentUser(item.staffId) ? 'rgb(28, 132, 198)' : null" [class.font-semibold]="isCurrentUser(item.staffId)">
                  @for (col of weekMonthYearColumns(); track col.field) {
                  <app-table-column [column]="col" [data]="item"></app-table-column>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="4" class="text-center p-4">
                    No registrations so far this year... it could start with you!
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          @if(allTimeLoading()) {
          <div>Loading...</div>
          }
          @else {
          <div *ngIf="allTimeRecruiterYearData.length > 0" class="all-time-leader mt-3 p-3 bg-surface-100 dark:bg-surface-800 rounded">
            <div class="text-sm font-semibold mb-1">All Time Leader:</div>
            <div class="flex justify-between items-center">
              <div class="flex items-center gap-2">
                <span>{{allTimeRecruiterYearData[0].staffName}}</span>
                <span class="text-sm text-500">({{allTimeRecruiterYearData[0].year}})</span>
              </div>
              <span class="text-primary">{{allTimeRecruiterYearData[0].participants}} participants</span>
              <span class="text-primary">{{allTimeRecruiterYearData[0].teams}} teams</span>
            </div>
          </div>
          <button pButton label="View All Time" (click)="showAllTimeTable('year')" class="p-button-text"></button>
          }
        </div>
      </div>
    </div>
  </div>
</p-card>

<!-- All Time Dialog -->
<p-dialog [(visible)]="showAllTimeDialog" [style]="{width: '50vw'}"
  [header]="'All Time ' + currentDialogTable + ' Leaderboard'">
  <p-table [value]="currentDialogTable === 'week' ? allTimeRecruiterWeekData : 
                    currentDialogTable === 'month' ? allTimeRecruiterMonthData : 
                    allTimeRecruiterYearData" styleClass="p-datatable-sm">
    <ng-template pTemplate="header">
      <tr>
        @for (col of dialogColumns(); track col.field) {
        <app-table-header [column]="col"></app-table-header>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        @for (col of dialogColumns(); track col.field) {
        <app-table-column [column]="col" [data]="item"></app-table-column>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="text-center p-4">
          No all-time {{currentDialogTable}} data available yet.
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

<!-- Expand Dialog -->
<p-dialog [(visible)]="showExpandDialog" [style]="{width: '95vw', height: '85vh'}"
  [header]="'Registration Leaderboard - All Data'" [modal]="true" [closable]="true" [dismissableMask]="true">
  <div class="grid grid-cols-3 gap-4" style="max-height: 75vh; overflow-y: auto;">
    <!-- Week Table -->
    <div class="table-container">
      <div class="flex justify-between items-center mb-2">
        <h3>This Week</h3>
        <app-icon-button 
          [icon]="icons.ppmSolid.csv" 
          [text]="false"
          textSize="text-xs"
          (onClick)="exportTableCSV('week')"
          pTooltip="Export Week CSV"
          tooltipPosition="top">
        </app-icon-button>
      </div>
      <div style="max-height: 60vh; overflow-y: auto; padding-right: 8px;">
        <p-table [value]="weekTableData" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="flex">
          <ng-template pTemplate="header">
            <tr>
              @for (col of weekMonthYearColumns(); track col.field) {
              <app-table-header [column]="col"></app-table-header>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr [style.color]="isCurrentUser(item.staffId) ? 'rgb(28, 132, 198)' : null" [class.font-semibold]="isCurrentUser(item.staffId)">
              @for (col of weekMonthYearColumns(); track col.field) {
              <app-table-column [column]="col" [data]="item"></app-table-column>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="4" class="text-center p-4">
                No registrations so far this week... it could start with you!
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <!-- Month Table -->
    <div class="table-container">
      <div class="flex justify-between items-center mb-2">
        <h3>This Month</h3>
        <app-icon-button 
          [icon]="icons.ppmSolid.csv" 
          [text]="false"
          textSize="text-xs"
          (onClick)="exportTableCSV('month')"
          pTooltip="Export Month CSV"
          tooltipPosition="top">
        </app-icon-button>
      </div>
      <div style="max-height: 60vh; overflow-y: auto; padding-right: 8px;">
        <p-table [value]="monthTableData" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="flex">
          <ng-template pTemplate="header">
            <tr>
              @for (col of weekMonthYearColumns(); track col.field) {
              <app-table-header [column]="col"></app-table-header>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr [style.color]="isCurrentUser(item.staffId) ? 'rgb(28, 132, 198)' : null" [class.font-semibold]="isCurrentUser(item.staffId)">
              @for (col of weekMonthYearColumns(); track col.field) {
              <app-table-column [column]="col" [data]="item"></app-table-column>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="4" class="text-center p-4">
                No registrations so far this month... it could start with you!
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <!-- Year Table -->
    <div class="table-container">
      <div class="flex justify-between items-center mb-2">
        <h3>This Year</h3>
        <app-icon-button 
          [icon]="icons.ppmSolid.csv" 
          [text]="false"
          textSize="text-xs"
          (onClick)="exportTableCSV('year')"
          pTooltip="Export Year CSV"
          tooltipPosition="top">
        </app-icon-button>
      </div>
      <div style="max-height: 60vh; overflow-y: auto; padding-right: 8px;">
        <p-table [value]="yearTableData" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="flex">
          <ng-template pTemplate="header">
            <tr>
              @for (col of weekMonthYearColumns(); track col.field) {
              <app-table-header [column]="col"></app-table-header>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr [style.color]="isCurrentUser(item.staffId) ? 'rgb(28, 132, 198)' : null" [class.font-semibold]="isCurrentUser(item.staffId)">
              @for (col of weekMonthYearColumns(); track col.field) {
              <app-table-column [column]="col" [data]="item"></app-table-column>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="4" class="text-center p-4">
                No registrations so far this year... it could start with you!
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</p-dialog>